import React from 'react';
import { ArrowLeftIcon, ClipboardCheckIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function IntroAssessmentPage() {
  return <div className="w-full min-h-screen bg-[#f8f8f8] py-6 px-6" data-id="element-1589">
      <div className="max-w-4xl mx-auto" data-id="element-1590">
        {/* Back button */}
        <div className="mb-4" data-id="element-1591">
          <Link to="/" className="flex items-center text-gray-600 hover:text-[#631bb7] transition-colors" data-id="element-1592">
            <ArrowLeftIcon size={20} className="mr-2" data-id="element-1593" />
            <span className="font-medium" data-id="element-1594">Go Back</span>
          </Link>
        </div>
        {/* Main content */}
        <div className="bg-white rounded-2xl p-6 md:p-8 border-2 border-gray-200" data-id="element-1595">
          {/* Progress Indicator */}
          <div className="flex items-center justify-center mb-8 text-sm md:text-base" data-id="element-1596">
            <div className="flex items-center" data-id="element-1597">
              <span className="font-bold text-[#631bb7]" data-id="element-1598">Assess</span>
              <span className="mx-2 text-gray-400" data-id="element-1599">→</span>
            </div>
            <div className="flex items-center" data-id="element-1600">
              <span className="text-gray-400" data-id="element-1601">Guide</span>
              <span className="mx-2 text-gray-400" data-id="element-1602">→</span>
            </div>
            <div className="flex items-center" data-id="element-1603">
              <span className="text-gray-400" data-id="element-1604">Empower</span>
            </div>
          </div>
          <div className="flex flex-col items-center text-center mb-8" data-id="element-1605">
            <div className="w-16 h-16 bg-[#631bb7] bg-opacity-5 rounded-2xl flex items-center justify-center mb-4 border border-[#631bb7] border-opacity-10" data-id="element-1606">
              <ClipboardCheckIcon size={36} className="text-[#631bb7]" data-id="element-1607" />
            </div>
            <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#111111] mb-3" data-id="element-1608">
              Family Safety Checkup
            </h1>
            <p className="text-gray-600 text-lg mb-2" data-id="element-1609">
              Get your personalized plan in under 3 minutes
            </p>
            <p className="text-[#111111] font-semibold" data-id="element-1610">
              No email required. No sales pitch. Just clarity.
            </p>
          </div>
          {/* What's Covered section */}
          <div className="mb-10" data-id="element-1611">
            <h2 className="text-xl font-bold text-center text-[#111111] mb-4" data-id="element-1612">
              We'll cover these key areas
            </h2>
            <p className="text-center text-gray-600 mb-6" data-id="element-1613">
              Skip anything that's not relevant — we'll adapt to your situation
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3" data-id="element-1614">
              <div className="flex items-center p-4 bg-white rounded-xl border-2 border-gray-200" data-id="element-1615">
                <span className="text-2xl mr-3" data-id="element-1616">🏠</span>
                <span className="text-[#111111] font-semibold" data-id="element-1617">
                  Home WiFi & Network
                </span>
              </div>
              <div className="flex items-center p-4 bg-white rounded-xl border-2 border-gray-200" data-id="element-1618">
                <span className="text-2xl mr-3" data-id="element-1619">📱</span>
                <span className="text-[#111111] font-semibold" data-id="element-1620">
                  Devices & Apps
                </span>
              </div>
              <div className="flex items-center p-4 bg-white rounded-xl border-2 border-gray-200" data-id="element-1621">
                <span className="text-2xl mr-3" data-id="element-1622">🔐</span>
                <span className="text-[#111111] font-semibold" data-id="element-1623">
                  Passwords & Accounts
                </span>
              </div>
              <div className="flex items-center p-4 bg-white rounded-xl border-2 border-gray-200" data-id="element-1624">
                <span className="text-2xl mr-3" data-id="element-1625">🛡️</span>
                <span className="text-[#111111] font-semibold" data-id="element-1626">
                  Privacy & Data Protection
                </span>
              </div>
            </div>
          </div>
          {/* Get Started button */}
          <div className="flex justify-center" data-id="element-1627">
            <Link to="/assessment" className="bg-[#631bb7] text-white px-8 py-4 rounded-lg font-bold no-underline hover:bg-[#521099] transition-all shadow-md" data-id="element-1628">
              Start Your Checkup
            </Link>
          </div>
        </div>
      </div>
    </div>;
}